export function myFoo(a, b) {
    return a + b;
}

export function GetAppAccFromParty(value) {
    const party = JSON.parse(localStorage.getItem('party'));
    const selectedParty = party.find(party => party.autoid === value);
    var AppAcc = { 'applicantid': 0, 'accountid': 0 }
    if (selectedParty.autoid !== 0) {
        if (selectedParty) {
            AppAcc = { 'applicantid': selectedParty.applicantId, 'accountid': selectedParty.accountId,'applicantname': selectedParty.applicantname,'accountname': selectedParty.accountname }
        } else {
            AppAcc = { 'applicantid': selectedParty.applicantId, 'accountid': selectedParty.accountId,'applicantname': selectedParty.applicantname,'accountname': selectedParty.accountname }
        }
    }
    return AppAcc;
}

export function formatDate(dateString) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
}
export function formatDatedt(dateString) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
}
export function contSCount(transarray, size) {
    var sCnt = 0;
    transarray.forEach((item) => {
        if (item.contsize == size) {
            sCnt = sCnt + 1
        }
    })
    return sCnt;
}

export function ConvertToISODate(dateStr) {
    var parts = dateStr.split("/")
    return `${parts[2]}-${parts[1]}-${parts[0]}`;    
}

export function isvalidDate(dateStr) {
    var dateval=ConvertToISODate(dateStr)
    return !isNaN(new Date(dateval));
    
}

export function getUserPermissionsForModule() {
    try {
        const moduleName = window.location.pathname.split('/').pop(); // Get the current module name from the URL
        console.log("Module Name:", moduleName); // Log the module name for debugging
        const menulist = JSON.parse(localStorage.getItem("menuItems") || "[]");
        console.log("Menu List:", menulist); // Log the menu list for debugging
        const modulePermissions = menulist.find(item => item.menu_action === moduleName);
        console.log("Module Permissions:", modulePermissions); // Log the module permissions for debugging
        const isview = Boolean(modulePermissions.viewaction);
        const isedit = Boolean(modulePermissions.editaction);
        const isdelete = Boolean(modulePermissions.deleteaction);
        console.log("View Permission:", isview);
        console.log("Edit Permission:", isedit);
        console.log("Delete Permission:", isdelete);
        const modulePermissionsarray = [isview, isedit, isdelete];
        return modulePermissionsarray;
    } catch (error) {
        console.error("Error fetching user permissions:", error);
        return [];
    }
}